import React, {Component, useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    Card,
    List,
    Popconfirm, Form, Switch, notification, Select
} from 'antd';
import 'moment/locale/zh-cn';
import moment from "moment";

const {Title, Text} = Typography;
const {Content} = Layout;

const Delete = (id) => {
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const showPopconfirm = () => {
        setOpen(true);
    };
    const handleOk = () => {
        setConfirmLoading(true);
        setTimeout(() => {
            setOpen(false);
            setConfirmLoading(false);

            fetch("https://pd.pokemonbye.com:8084/api/setsellstockstate?state=0&id=" + id.id)
                .then(res => res.json())
                .then(
                    (result) => {
                        window.location.reload()

                    },
                    (error) => {
                    }
                )
        }, 1000);
    };
    const handleCancel = () => {
        console.log('删除后将不可恢复');
        setOpen(false);
    };
    return (
        <Popconfirm
            title="删除后将不可恢复"
            open={open}
            onConfirm={handleOk}
            okButtonProps={{
                loading: confirmLoading,
            }}
            onCancel={handleCancel}
        >
            <Button onClick={showPopconfirm}>
                删除
            </Button>
        </Popconfirm>
    );
};
const onChange = (checked) => {
    console.log(`switch to ${checked}`);/*
    var list = this.state.list
    list.type = checked
    this.setState({
        isLoaded: true,
        list: list
    });*/
};
const openNotification = () => {
    notification.open({
        message: '提交成功',
        description:
            '产品信息修改成功',
        onClick: () => {
            console.log('提交成功');
        },
    });
};

class PageSellCar extends Component {


    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        this.state = {
            title: "车辆编辑",
            county: [],
            id: id,
            list: [],
            options: []
        };
    }

    componentDidMount() {
        var id = this.state.id
        if(id){
            fetch("https://pd.pokemonbye.com:8084/api/getselltruckbyid?id=" + id)
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data;
                        if(array != null && array.length >0){
                            this.setState({
                                isLoaded: true,
                                list: array[0]
                            });
                            this.formRef.current.setFieldsValue(array[0])
                        }
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
        fetch("https://pd.pokemonbye.com:8084/api/getsellclientlist")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    var menu = [];
                    for (let i = 0; i < array.length; i++) {
                        menu.push(
                            {
                                value: array[i].id,
                                label: array[i].name
                            }
                        )
                    }
                    this.setState({
                        isLoaded: true,
                        menu: menu
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        fetch("https://pd.pokemonbye.com:8084/api/gettrucklet")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    var menu = [];
                    for (let i = 0; i < array.length; i++) {
                        menu.push(
                            {
                                value: array[i].trucklet_id,
                                label: array[i].trucklet_name
                            }
                        )
                    }
                    this.setState({
                        isLoaded: true,
                        menus: menu
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }
    formRef = React.createRef();
    render() {
        const onFinish = (values) => {
            var list = {};
            list.name = values.name ? values.name : this.state.list.name;
            list.clientid = values.clientid ? values.clientid : this.state.list.clientid;
            list.let = values.letid ? values.letid : this.state.list.letid;
            list.num = values.num ? values.num : this.state.list.num;
            list.time = moment().format('YYYY-MM-DD HH:mm:ss') ;
            console.log(list)
            if(this.state.id){
            list.id = this.state.id;
                function queryParse(query){
                    let queryText = "";
                    for(let key in query){
                        queryText += `${key}=${query[key]}&`;
                    }
                    return queryText.slice(0,-1);
                }

                fetch("https://pd.pokemonbye.com:8084/api/setselltruck",
                    {
                        method:'post',
                        body:queryParse(list),
                        headers:{
                            'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                        }
                    })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            openNotification();

                            setTimeout(window.location.href="/pagesellcars",1000);
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            this.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            }else{
                function queryParse(query){
                    let queryText = "";
                    for(let key in query){
                        queryText += `${key}=${query[key]}&`;
                    }
                    return queryText.slice(0,-1);
                }

                fetch("https://pd.pokemonbye.com:8084/api/insertselltruck",
                    {
                        method:'post',
                        body:queryParse(list),
                        headers:{
                            'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                        }
                    })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            openNotification();

                            setTimeout(window.location.href="/pagesellcars",1000);
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            this.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            }
        };
        return (
            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            >
                                <Form
                                    labelCol={{
                                        span: 4,
                                    }}
                                    wrapperCol={{
                                        span: 6,
                                    }}
                                    layout="horizontal"
                                    size="Large"
                                    onFinish={onFinish}
                                    ref={this.formRef}
                                >{/*
                                    <Form.Item label="产品编号" name="stockid">
                                        <Input disabled={false} bordered={false} placeholder={this.state.list.stockid}/>
                                    </Form.Item>*/}
                                    <Form.Item label="车牌号" name="name">
                                        <Input/>
                                    </Form.Item>
                                    <Form.Item label="行驶证号码" name="num">
                                        <Input/>
                                    </Form.Item>
                                    <Form.Item label="排放标准" name="letid">
                                        <Select
                                            placeholder='请选择'
                                            style={{
                                                width: 120,
                                            }}
                                            options={this.state.menus}
                                        />
                                    </Form.Item>
                                    <Form.Item label="所属客户" name="clientid">
                                        <Select
                                            placeholder='请选择'
                                            style={{
                                                width: 220,
                                            }}
                                            options={this.state.menu}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        wrapperCol={{
                                            offset: 4,
                                            span: 16,
                                        }}
                                    >
                                        <Button type="primary" htmlType="submit">{this.state.id?'提交修改':'新建'}</Button>
                                    </Form.Item>
                                </Form>

                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageSellCar;


